import md5 from 'js-md5';
import storageMode from '@/storage';
import crypto from './crypto';

const addZero = item => {
  item = item < 10 ? '0' + item : item;
  return item;
};

/* 时间戳转换成"yyyy-mm-dd hh:mm:ss"格式 */
const getTime = time => {
  let newTime = new Date();
  if (time) {
    newTime = new Date(time);
  }
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());
  let Hour = addZero(newTime.getHours());
  let Minute = addZero(newTime.getMinutes());
  let Second = addZero(newTime.getSeconds());

  return `${Year}-${Month}-${Day} ${Hour}:${Minute}:${Second}`;
};

const getTimeByDay = (time, day = 0, monthStart = false) => {
  let newTime = new Date().getTime();
  if (time) {
    newTime = new Date(time).getTime();
  }
  newTime -= 1000 * 60 * 60 * 24 * (day);
  newTime = new Date(newTime);
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());
  monthStart ? Day = '01' : '';
  return `${Year}-${Month}-${Day}`;
};

const getTimeByMonth = (time, mon = 0) => {
  return getTimeByDay(time, mon * 30);
};

const getTimeALL = time => {
  let newTime = new Date();
  if (time) {
    newTime = new Date(time);
  }
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());
  let Hour = addZero(newTime.getHours());
  let Minute = addZero(newTime.getMinutes());
  let Second = addZero(newTime.getSeconds());
  let milliSeconds = newTime.getMilliseconds();
  return `${Year}${Month}${Day}${Hour}${Minute}${Second}${milliSeconds}`;
};
const getTime2 = time => {
  let newTime = new Date();
  if (time) {
    newTime = new Date(time);
  }
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());
  let Hour = addZero(newTime.getHours());
  let Minute = addZero(newTime.getMinutes());
  let Second = addZero(newTime.getSeconds());
  return `${Year}${Month}${Day}${Hour}${Minute}${Second}`;
};
const getTimeToMonth = time => {
  let newTime = new Date();
  if (time) {
    newTime = new Date(time);
  }
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);

  return `${Year}年${Month}月`;
};

const getTimeToDay = time => {
  let newTime = new Date();
  if (time) {
    newTime = new Date(time);
  }
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());

  return `${Year}年${Month}月${Day}日`;
};
// 时间截取
const parseTimeNumber = val => {
  let _time = '';
  if (val && val.slice) {
    let Year = val.slice(0, 4);
    let Month = val.slice(4, 6);
    let Day = val.slice(6, 8);
    let Hour = val.slice(8, 10);
    let Minute = val.slice(10, 12);
    let Second = val.slice(12, 14);
    _time = `${Year}-${Month}-${Day} ${Hour}:${Minute}:${Second}`;
  }

  return _time;
};

const transforTree = treeData => {
  if (!treeData || treeData.length === 0) {
    return [];
  }
  const childs = [];
  treeData.forEach(tree => {
    if (tree.childRepDepConfigs && tree.childRepDepConfigs.length > 0) {
      childs.push({
        value: tree.depCode,
        label: tree.depName,
        children: transforTree(tree.childRepDepConfigs),
      });
    }
    else {
      childs.push({
        value: tree.depCode,
        label: tree.depName,
      });
    }
  });
  return childs;
};
const regRule = {
  idCard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
  phone: /^[0-9]{7,}$/,
  nGInteger: /^\d+$/, // 排序号
  code: /^[0-9a-zA-Z]+$/, // 編号
  isComponent: /^[a-zA-Z]+$/, // 字母
};
/**
 * 去抖动
 * @param {*} fn
 * @param {*} delay
 */
const debounce = (fn, delay) => {
  let timeoutID = null;
  return function later(...args) {
    clearTimeout(timeoutID);
    let that = this;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
};

/**
 * 转义html
 * @param {*} html
 */
const encodeHtml = html => ((html && html.replace) ? (
  html.replace(/&/g, '&amp;') // 转换&符号
    .replace(/ /g, '&nbsp;') // 转换空格
    .replace(/\b&nbsp;+/g, ' ') // 转换多个空格为单个空格
    .replace(/</g, '&lt;') // 转换小于符号
    .replace(/>/g, '&gt;') // 转换大于符号
    .replace(/\\/g, '&#92;') // 转换斜杠符号
    .replace(/\'/g, '&#39;') // 转换单引号
    .replace(/\"/g, '&quot;') // 转换双引号
    .replace(/\n/g, '<br/>') // 转换换行符号
    .replace(/\r/g, '') // 转换回车符号
) : html);

// 去除\N字符
const dealData = datas => {
  if (!datas) {
    return {};
  }
  if (datas.constructor === Array) {
    for (let i = 0; i < datas.length; i++) {
      let item = datas[i];
      for (let key in item) {
        if (item[key] === '\\N') {
          item[key] = '';
        }
      }
    }
  }
  else if (datas.constructor === Object) {
    for (let key in datas) {
      if (datas[key] === '\\N') {
        datas[key] = '无';
      }
    }
  }
  return datas;
};

const getTimeString = (newTime = new Date()) => {
  let Year = newTime.getFullYear();
  let Month = addZero(newTime.getMonth() + 1);
  let Day = addZero(newTime.getDate());

  return `${Year}${Month}${Day}`;
};
const calcuMD5 = pwd => {
  // pwd = pwd.toUpperCase();//小写转大写
  pwd = md5(md5(pwd) + 'hg');
  return pwd;
};
const getToken = () => {
  const storage = storageMode['localStorage'];
  return storage.$get({
    key: 'TOKEN',
  });
};
const setToken = ({
                    key,
                    parameter,
                    date,
                    reflush,
                    url,
                  }) => {
  const storage = storageMode['localStorage'];
  return storage.$set({
    key,
    parameter,
    date,
    reflush,
    url,
  });
};

const removeToken = () => {
  const storage = storageMode['localStorage'];
  return storage.$remove({
    key: 'TOKEN',
  });
};
const setStorage = ({
                      type,
                      key,
                      parameter,
                      date,
                      reflush,
                      url,
                    }) => {
  const storage = storageMode[type];
  return storage.$set({
    key,
    parameter,
    date,
    reflush,
    url,
  });
};
const getStorage = ({
                      type,
                      key,
                    }) => {
  const storage = storageMode[type];
  return storage.$get({
    key,
  });
};
const removeStorage = ({
                         type,
                         key,
                       }) => {
  const storage = storageMode[type];
  return storage.$remove({
    key,
  });
};

// 计算uuid
const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);

const getUid = () => (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());

// 生成指定范围数组
const getIntArry = (start, end) => {
  let _length = end - start + 1;
  let step = start - 1;
  let f = length => Array.from({
    length,
  }).map((v, k) => k);
  return f(_length).map(() => {
    step++;
    return step;
  });
};

const formatJson = (filterVal, jsonData) => (jsonData.map(v => filterVal.map(j => (v[j] ? String(v[
  j]) : ''))));

/* eslint global-require: "off" */
/* eslint import/no-dynamic-require: "off" */
const generateExcel = ({
                         tHeader,
                         list,
                         filterVal,
                         excelName,
                         colWidth,
                         colType
                       }) => {
  require.ensure([], () => {
    const {
      export_json_to_excel,
    } = require('@/vendor/Export2Excel');
    const data = formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, excelName, colWidth, colType);
  });
};

const transJson = d => {
  let code = [];
  let nam = [];
  let arr = [];
  for (let i = 0; i < d.length; i++) {
    if (i === 0) {
      code.push(d[0].depCode);
      nam.push(d[0].depName);
      let ob = {
        jqzs: d[0].jqzs,
        yxjq: d[0].yxjq,
        date: d[0].date,
      };
      let obj = {
        depCode: d[0].depCode,
        depName: d[0].depName,
        data: [],
      };
      obj['data'].push(ob);
      arr.push(obj);
    }
    else if (code.indexOf(d[i].depCode) === -1) {
      code.push(d[i].depCode);
      nam.push(d[i].depName);
      let ob = {
        jqzs: d[i].jqzs,
        yxjq: d[i].yxjq,
        date: d[i].date,
      };
      let obj = {
        depCode: d[i].depCode,
        depName: d[i].depName,
        data: [],
      };
      obj['data'].push(ob);
      arr.push(obj);
    }
    else {
      let idx = code.indexOf(d[i].depCode);
      let ob = {
        jqzs: d[i].jqzs,
        yxjq: d[i].yxjq,
        date: d[i].date,
      };
      arr[idx]['data'].push(ob);
    }
  }
  return arr;
};
const transClassJson = d => {
  let code = [];
  let nam = [];
  let arr = [];
  for (let i = 0; i < d.length; i++) {
    if (i === 0) {
      code.push(d[0].lbdm);
      nam.push(d[0].lbmz);
      let ob = {
        jqzs: d[0].jqzs,
        date: d[0].date,
      };
      let obj = {
        lbdm: d[0].lbdm,
        lbmz: d[0].lbmz,
        data: [],
      };
      obj['data'].push(ob);
      arr.push(obj);
    }
    else if (code.indexOf(d[i].lbdm) === -1) {
      code.push(d[i].lbdm);
      nam.push(d[i].lbmz);
      let ob = {
        jqzs: d[i].jqzs,
        date: d[i].date,
      };
      let obj = {
        lbdm: d[i].lbdm,
        lbmz: d[i].lbmz,
        data: [],
      };
      obj['data'].push(ob);
      arr.push(obj);
    }
    else {
      let idx = code.indexOf(d[i].lbdm);
      let ob = {
        jqzs: d[i].jqzs,
        date: d[i].date,
      };
      arr[idx]['data'].push(ob);
    }
  }
  return arr;
};

const downLoad = (blob, fileName) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  }
  else {
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
};

const deepCopy = data => {
  let copyed_objs = [];// 此数组解决了循环引用和相同引用的问题，它存放已经递归到的目标对象
  function _deepCopy(target) {
    if ((typeof target !== 'object') || !target) {
      return target;
    }
    for (let i = 0; i < copyed_objs.length; i++) {
      if (copyed_objs[i].target === target) {
        return copyed_objs[i].copyTarget;
      }
    }
    let obj = {};
    if (Array.isArray(target)) {
      obj = [];// 处理target是数组的情况
    }
    copyed_objs.push({target, copyTarget: obj});
    Object.keys(target).forEach(key => {
      if (obj[key]) {
        return;
      }
      obj[key] = _deepCopy(target[key]);
    });
    return obj;
  }

  return _deepCopy(data);
};
// 只判断一层
const targetIsChange = (target, data) => {
  if (typeof (target) === 'string') {
    return target === data;
  }
  if (typeof (target) === 'object') {
    let bool = false;
    for (let key in target) {
      if (target[key] !== data[key]) {
        bool = true;
        break;
      }
    }

    return bool;
  }
};


//浮点数计算
const FloatCalculation = (a, b, op) => {
  let o1 = toInteger(a);
  let o2 = toInteger(b);
  let n1 = o1.num;
  let n2 = o2.num;
  let t1 = o1.times;
  let t2 = o2.times;
  let max = t1 > t2 ? t1 : t2;
  let result = null;
  switch (op) {
    case 'add':
      if (t1 === t2) { // 两个小数位数相同
        result = n1 + n2
      } else if (t1 > t2) { // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2)
      } else { // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2
      }
      return result / max;
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) - n2
      }
      return result / max;
    case 'multiply':
      result = (n1 * n2) / (t1 * t2);
      return result;
    case 'divide':
      result = (n1 / n2) * (t2 / t1);
      return result
  }
}
const toInteger = floatNum => {
  let ret = {times: 1, num: 0};
  if (isInteger(floatNum)) {
    ret.num = floatNum;
    return ret
  }
  let strfi = floatNum + '';
  let dotPos = strfi.indexOf('.');
  let len = strfi.substr(dotPos + 1).length;
  let times = Math.pow(10, len);
  let specialNum = (floatNum * times) < 0 ? (floatNum * times - 0.5) : (floatNum * times + 0.5)
  let intNum = parseInt(specialNum, 10);
  ret.times = times;
  ret.num = intNum;
  return ret
}
const isInteger = obj => {
  return Math.floor(obj) === obj
}


const getFloat = (num, n) => {
  if (!num && num != 0) return ''
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(num);
  }
  num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
  num = Number(num).toFixed(n);
  return num;
}

export default {
  getUid,
  getTime,
  getTimeALL,
  getTime2,
  parseTimeNumber,
  transforTree,
  getTimeToMonth,
  getTimeToDay,
  regRule,
  debounce,
  encodeHtml,
  dealData,
  getTimeString,
  calcuMD5,
  setToken,
  getToken,
  removeToken,
  setStorage,
  getStorage,
  removeStorage,
  getTimeByDay,
  getTimeByMonth,
  crypto,
  getIntArry,
  generateExcel,
  transJson,
  transClassJson,
  downLoad,
  deepCopy,
  targetIsChange,
  FloatCalculation,
};
